//import React from 'react';
import React, {useState} from 'react';
//import ReactDOM from 'react-dom';

//React-hooks

export default function Counter({initVal:init_val=5}){

  let [counterVal,setCounterF] = useState(init_val); //=React.useState(init_val);
  
  return (
    <div style={{textAlign:'center'}}> 
      <button onClick={() => setCounterF(counterVal + 1)}
      >counterVal= {counterVal} </button>
      
    <hr/>
    </div>
  );
}
